import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import {
  createUtkarshTheme,
  readStoredPaletteId,
  writeStoredPaletteId,
} from '../theme/theme';

const BrandPaletteContext = createContext({
  paletteId: 'classic',
  setPaletteId: () => {},
});

export function useBrandPalette() {
  return useContext(BrandPaletteContext);
}

export function BrandPaletteProvider({ children }) {
  const [paletteId, setPaletteIdState] = useState(() => readStoredPaletteId());

  const setPaletteId = useCallback((id) => {
    const next = ['logoBrand', 'matchClarity', 'classic'].includes(id) ? id : 'classic';
    writeStoredPaletteId(next);
    setPaletteIdState(next);
  }, []);

  const theme = useMemo(() => createUtkarshTheme(paletteId), [paletteId]);

  const value = useMemo(
    () => ({ paletteId, setPaletteId }),
    [paletteId, setPaletteId],
  );

  return (
    <BrandPaletteContext.Provider value={value}>
      <ColorModeScript
        initialColorMode={theme.config.initialColorMode}
        storageKey={theme.config.storageKey}
      />
      <ChakraProvider theme={theme} key={paletteId}>
        {children}
      </ChakraProvider>
    </BrandPaletteContext.Provider>
  );
}
